import { render, staticRenderFns } from "./health.vue?vue&type=template&id=c1feef3c&scoped=true&"
import script from "./health.vue?vue&type=script&lang=js&"
export * from "./health.vue?vue&type=script&lang=js&"
import style0 from "./health.vue?vue&type=style&index=0&id=c1feef3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1feef3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1feef3c')) {
      api.createRecord('c1feef3c', component.options)
    } else {
      api.reload('c1feef3c', component.options)
    }
    module.hot.accept("./health.vue?vue&type=template&id=c1feef3c&scoped=true&", function () {
      api.rerender('c1feef3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chronic/components/health.vue"
export default component.exports